module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz84aGhudNAP81HP8YDPsYAOccAGk9AP8MAP8EAOsIBPMAAOMAADUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///yH5BAEHAB8ALAAAAAAgACAAAAXg4CeO5OedaOoBZeuaXiLP8/neYkwnDH14OJeOppgpFgJgsBRD7GSL2pLJS6hQiYVymrNaNNeTljuKqTiblJWcM4fdbNjwiYqfOs8aZss9bfIyHmB2HhOAVjZsJ4eBfFOLA4eJZCcRkhaOSycQkntkATCGgB5pH6BLAQEeFzoFBDJOCiipXKp4jCenfWYNFBUODw8cGoh2iG9/mUE6pCoYt8o4Ma8JGBISGBg00TfTPFFGUooJr0VE4Nwv3uZG6MYFCewyCubpQiPyWWVxHxkiBlDILcjBT4S/PCYKlnkTJAQAOw=="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadS.gif
// module id = VXhZ
// module chunks = 48